module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-7b7cc516.png";